import React, { useRef } from 'react';

type IllustrationName = 'groupOfPeople';

interface Image {
  name: string;
  images: number;
  alt: string[];
}

interface Props {
  variant: IllustrationName;
  className?: string;
}

const illustrations: Record<IllustrationName, Image> = {
  groupOfPeople: {
    name: 'group-of-people',
    images: 2,
    alt: [''],
  },
};

export default function Illustration({
  variant,
  className,
}: Props): JSX.Element {
  const illustration = illustrations[variant];
  const n = useRef<number>(Math.floor(Math.random() * illustration.images) + 1);
  return (
    <img
      className={className}
      alt={illustration.alt[n.current]}
      src={`/img/${illustration.name}-${n.current}.svg`}
    />
  );
}
